import { Fault } from "./fault";

export interface FaultListObject {
  id?: string;
  label: string;
  faults?: Fault[];
}

export class FaultList {
  public id?: string;
  label: string;
  faults?: Fault[];
  constructor(faultList: FaultListObject) {
    this.id = faultList.id;
    this.label = faultList.label;
    this.faults = faultList.faults?.sort((a, b) => {
      if (a.faultCode && b.faultCode) {
        return a.faultCode.localeCompare(b.faultCode);
      } else {
        return 0;
      }
    });
  }

  set properties(faultList: FaultListObject) {
    if (faultList.label) {
      this.label = faultList.label;
    }
    this.label = faultList.label;
    if (faultList.faults) {
      this.faults = faultList.faults;
    }
  }

  get values() {
    const faultList: FaultListObject = {
      label: this.label,
    };
    return faultList;
  }
}
